import React from 'react';
import './TelegramAuthRequiredPage.css'; // Предполагаем, что стили будут в этом файле

const TelegramAuthRequiredPage = () => {
  return (
    <div className="telegram-auth-required-page">
      <div className="message-container">
        <h1>Ошибка авторизации</h1>
        <p>Это приложение предназначено для использования внутри Telegram.</p>
        <p>Пожалуйста, запустите его через бота в Telegram.</p>
      </div>
    </div>
  );
};

export default TelegramAuthRequiredPage;
